
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.416 8.658L8.45 1.424h-.072c-3.513.01-6.358 2.915-6.368 6.502V8l7.406.658z","fill":"#F5B912"}}),_c('path',{attrs:{"d":"M8.521 1.424H8.45V8l3.22 1.315L14.89 8v-.074c-.01-3.587-2.855-6.492-6.368-6.502z","fill":"#F5B912"}}),_c('path',{attrs:{"d":"M14.89 8v.072c-.01 3.588-2.855 6.494-6.369 6.504H8.38c-3.513-.01-6.36-2.916-6.37-6.504V8h12.882z","fill":"#F5B912"}}),_c('g',{attrs:{"filter":"url(#filter0_d_1199_17050)"}},[_c('path',{attrs:{"d":"M1.583 4H5l3 3v5.334c0 .368-.261.666-.583.666H1.583C1.261 13 1 12.702 1 12.334V4.667C1 4.298 1.261 4 1.583 4z","fill":"#F5B912"}})]),_c('path',{attrs:{"d":"M5 4l3 3H6a1 1 0 01-1-1V4z","fill":"#FFE499"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":".5","d":"M2.25 8.25h4.5v2.5h-4.5z"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_1199_17050","x":"1","y":"4","width":"7.6","height":"9.6","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dx":".5","dy":".5"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":".05"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.234078 0 0 0 0 0.259283 0 0 0 0 0.334896 0 0 0 0.55 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_1199_17050"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_1199_17050","result":"shape"}})])])])
          )
        }
      }
    